import { useEffect, useRef } from 'react';

import { NOOP } from '../../../../constants';
import { usePrivatePresenceWebsocketService } from '../usePrivatePresenceWebsocketService';

export const useSubscribeToPrivatePresenceWebsocketEvent = (
  channelName: string | undefined,
) => {
  const privatePresenceWebsocketService = usePrivatePresenceWebsocketService();
  const unsubscribeRef = useRef<() => void | undefined>(undefined);

  useEffect(() => {
    if (channelName) {
      // add a generic callback and event name so that we connect to the channel
      unsubscribeRef.current = privatePresenceWebsocketService.subscribeToEvent(
        channelName,
        'join',
        NOOP,
      );
    }
    return unsubscribeRef.current;
  }, [channelName]);

  // Handle beforeunload -> leave channel
  useEffect(() => {
    const handleBeforeUnload = () => {
      unsubscribeRef.current?.();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [channelName]);
};
